import React from "react";
import Stars from "../shared/stars";
import UserAvatar from "../../images/icons/avatar.svg";
import { __t } from "../../utils/translate";
import US from "../../images/flags/us.svg";
import DK from "../../images/flags/dk.svg";
import AT from "../../images/flags/at.svg";
import AU from "../../images/flags/au.svg";
import BE from "../../images/flags/be.svg";
import DE from "../../images/flags/de.svg";
import CH from "../../images/flags/ch.svg";
import CZ from "../../images/flags/cz.svg";
import CA from "../../images/flags/ca.svg";
import ES from "../../images/flags/es.svg";
import FI from "../../images/flags/fi.svg";
import FR from "../../images/flags/fr.svg";
import GB from "../../images/flags/gb.svg";
import GR from "../../images/flags/gr.svg";
import HU from "../../images/flags/hu.svg";
import IE from "../../images/flags/ie.svg";
import IT from "../../images/flags/it.svg";
import NL from "../../images/flags/nl.svg";
import NO from "../../images/flags/no.svg";
import NZ from "../../images/flags/nz.svg";
import PT from "../../images/flags/pt.svg";
import RO from "../../images/flags/ro.svg";
import SE from "../../images/flags/se.svg";

const flagMapper = {
    'us': { flag: US, name: 'United States' },
    'dk': { flag: DK, name: 'Denmark' },
    'at': { flag: AT, name: 'Austria' },
    'au': { flag: AU, name: 'Australia' },
    'be': { flag: BE, name: 'Belgium' },
    'de': { flag: DE, name: 'Germany' },
    'ch': { flag: CH, name: 'Switzerland' },
    'cz': { flag: CZ, name: 'Czech Republic' },
    'ca': { flag: CA, name: 'Canada' },
    'es': { flag: ES, name: 'Spain' },
    'fi': { flag: FI, name: 'Finland' },
    'fr': { flag: FR, name: 'France' },
    'uk': { flag: GB, name: 'United Kingdom' },
    'gr': { flag: GR, name: 'Greece' },
    'hu': { flag: HU, name: 'Hungary' },
    'ie': { flag: IE, name: 'Ireland' },
    'it': { flag: IT, name: 'Italy' },
    'nl': { flag: NL, name: 'Netherlands' },
    'no': { flag: NO, name: 'Norway' },
    'nz': { flag: NZ, name: 'New Zealand' },
    'pt': { flag: PT, name: 'Portugal' },
    'ro': { flag: RO, name: 'Romania' },
    'se': { flag: SE, name: 'Sweden' }
};

export const countrySelector = () => {
    let code = 'us';
    if (process.env.GATSBY_API) {
        code = process.env.GATSBY_API.split('.').pop();
    }
    let flag = flagMapper[code];
    return flag ? flag : flagMapper['us'];
}

const currentCountry = countrySelector();

interface ProductReviewCardProps {
    className?: string;
    userName: string;
    description: string;
    avatarSrc?: string;
    rating?: number;
    isVerified: string;
    date: string;
}

const ProductReviewCard: React.FC<ProductReviewCardProps> = ({
    className = "",
    userName,
    avatarSrc = UserAvatar,
    description,
    rating,
    isVerified,
    date,
}) => {
    const dateFormatted = new Date(date).toLocaleDateString("en-GB");

    function enhanceImageTagInDescription(description: string) {
        const imgTagPattern = /(<img [^>]*src=")([^"]*)("[^>]*>)/i;
        const hostname = process.env.GATSBY_API;

        const enhancedImageTag = description.replace(imgTagPattern, (imageTag, start, src, end) => {
            const updatedSrc = src.startsWith('http') ? src : `https://${hostname}${src}`;
            const updatedTag = start + updatedSrc + end;

            return updatedTag.includes('loading=')
                ? updatedTag
                : updatedTag.replace(/<img /, '<img loading="lazy" width="300" height="300" onerror="this.style.display=`none`"');
        });

        return enhancedImageTag;
    }

    const enhancedDescription = enhanceImageTagInDescription(description);

    return (
        <div
            className={`${className} ${isVerified === 'approved' ? '' : 'hidden'} flex gap-[12px] overflow-hidden border-b border-stroke-color py-1 mb-[40px] text-body-text-color `}
        >
            <div className={`relative flex grow flex-col`}>
                {!!rating && (
                    <Stars
                        width="100"
                        height="20"
                        className="mb-1"
                        rating={rating}
                        useNewDesign={true}
                    />
                )}
                <span className="text-base-16 lg:text-h3-r text-dark">{userName} <span className="text-small-14 lg:text-18 text-dark opacity-50">({__t("verified buyer")})</span></span>
                <div className="mb-3 flex flex-row gap-2 items-center">
                    <img src={currentCountry.flag} alt="" className="h-[14px]" width="21px" height="14px"></img>
                    {/* {isVerified && ( */}
                    <span className="text-small-14 text-dark">{__t(currentCountry.name)}</span>
                    {/* )} */}
                    {/* <span className="ml-auto text-sm">{dateFormatted}</span> */}
                </div>
                <div
                    className="review-description mb-0 text-base-16 text-dark px-1"
                    dangerouslySetInnerHTML={{ __html: enhancedDescription || "" }}
                ></div>
            </div>
        </div>
    );
};

export default ProductReviewCard;
